/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { FeeCollector, FeeCollectorInterface } from "../FeeCollector";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "AuthorizedAddressAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "AuthorizedAddressRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "addAuthorizedAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "authorities",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "authorized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IEtherTokenV06",
        name: "weth",
        type: "address",
      },
    ],
    name: "convertToWeth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAuthorizedAddresses",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IEtherTokenV06",
        name: "weth",
        type: "address",
      },
      {
        internalType: "contract IStaking",
        name: "staking",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "poolId",
        type: "bytes32",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "removeAuthorizedAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "removeAuthorizedAddressAtIndex",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class FeeCollector__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FeeCollector> {
    return super.deploy(overrides || {}) as Promise<FeeCollector>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): FeeCollector {
    return super.attach(address) as FeeCollector;
  }
  connect(signer: Signer): FeeCollector__factory {
    return super.connect(signer) as FeeCollector__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FeeCollectorInterface {
    return new utils.Interface(_abi) as FeeCollectorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FeeCollector {
    return new Contract(address, _abi, signerOrProvider) as FeeCollector;
  }
}
